import { Link } from "react-router-dom";
import { Icons } from "../components/Icons";
import { ScreenHeader } from "../components/ScreenHeader";
import { useRole } from "../lib/auth/useRole";
import { navForRole } from "../lib/nav";

/** Tout ce qui n'est pas le temps : terrain, tâches, équipe, réglages. */
export function MoreScreen() {
  const { more } = navForRole(useRole());
  return (
    <>
      <ScreenHeader title="Plus" />
      <ul className="settings-list more-list">
        {more.map((item) => (
          <li key={item.id}>
            <Link to={item.path} className="set-row more-row">
              <span className="ic">
                <item.icon size={17} sw={1.8} />
              </span>
              <span className="text">
                <span className="lbl">{item.label}</span>
              </span>
              <Icons.chev size={14} />
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}

export default MoreScreen;
